import { Button, Flex } from '@chakra-ui/react';

import { Box, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { RiMenu5Line } from "react-icons/ri";
import { displayReactIcon } from "../helpers/dsr-display-helpers";

export default function DsrActionOptionsButton({
  isActive, 
  actionId, 
  mapCategoryId, 
  handleClickViewDetailsOption, 
  handleClickEditActionOption, 
  handleClickDeleteActionOption
} ) {

  return (
    <Menu closeOnSelect={true} >
      <MenuButton as={Button} bg='white' rounded='0.5em' height='5em' width='5em' justifyContent='flex-end' p='0.5em' justify='center'>
        <Flex w='100%' justify='center'>
          <RiMenu5Line fontSize="1.4em"/>
        </Flex>
      </MenuButton>
      <MenuList  minWidth="10em" boxShadow="xs" fontSize='0.875em'>
        <Box color='brandDark.500' > <MenuItem className='filter-menu__dropdown-option-display' px='1em' onClick={()=>handleClickViewDetailsOption(mapCategoryId, actionId)}> {displayReactIcon("copy","1.2em") } View details</MenuItem> </Box>
        <Box color='brandDark.500'> <MenuItem className='filter-menu__dropdown-option-display' px='1em'  isDisabled={isActive ? false : true} onClick={()=>handleClickEditActionOption(mapCategoryId, actionId)} > {displayReactIcon("edit","1.2em")} Edit action </MenuItem> </Box>
        <Box color='red.400'> <MenuItem className='filter-menu__dropdown-option-display' px='1em' isDisabled={isActive ? false : true}  onClick={()=>handleClickDeleteActionOption(mapCategoryId, actionId)}> {displayReactIcon("delete","1.2em")} Delete action </MenuItem> </Box>
      </MenuList>
    </Menu>
  );
  
}

